import React from "react";

export default function TrashIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg
      viewBox="0 0 14 14"
      style={{ ...filteredStyles, fill: "none" }}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.70068 4.10156L2.42718 12.8717C2.47924 13.5041 3.01797 14 3.65284 14H10.3467C10.9816 14 11.5203 13.5041 11.5724 12.8717L12.2988 4.10156H1.70068ZM4.9486 12.3594C4.7339 12.3594 4.55327 12.1924 4.53965 11.9748L4.12949 5.35765C4.11546 5.13136 4.28729 4.9367 4.51321 4.92267C4.74752 4.90623 4.93378 5.08009 4.94819 5.30638L5.35835 11.9236C5.37287 12.1579 5.18745 12.3594 4.9486 12.3594ZM7.40992 11.9492C7.40992 12.1759 7.22647 12.3594 6.99977 12.3594C6.77306 12.3594 6.58961 12.1759 6.58961 11.9492V5.33203C6.58961 5.10532 6.77306 4.92188 6.99977 4.92188C7.22647 4.92188 7.40992 5.10532 7.40992 5.33203V11.9492ZM9.87004 5.35768L9.45988 11.9749C9.4464 12.1902 9.26695 12.3696 9.0249 12.3586C8.79898 12.3446 8.62716 12.1499 8.64118 11.9236L9.05134 5.30641C9.06537 5.08011 9.26364 4.91548 9.48632 4.9227C9.71224 4.93672 9.88407 5.13138 9.87004 5.35768Z" fill={filteredStyles.fill}/>
      <path d="M12.332 1.64062H9.87109V1.23047C9.87109 0.551961 9.31913 0 8.64062 0H5.35938C4.68087 0 4.12891 0.551961 4.12891 1.23047V1.64062H1.66797C1.21491 1.64062 0.847656 2.00788 0.847656 2.46094C0.847656 2.91394 1.21491 3.28125 1.66797 3.28125C5.44048 3.28125 8.55966 3.28125 12.332 3.28125C12.7851 3.28125 13.1523 2.91394 13.1523 2.46094C13.1523 2.00788 12.7851 1.64062 12.332 1.64062ZM9.05078 1.64062H4.94922V1.23047C4.94922 1.00417 5.13308 0.820312 5.35938 0.820312H8.64062C8.86692 0.820312 9.05078 1.00417 9.05078 1.23047V1.64062Z" fill={filteredStyles.fill}/>
    </svg>
  );
}
